import React, {Component} from 'react';
import PropTypes from 'prop-types';

class WebinarInnerInfo extends Component {
    render() {
    const webinar = this.props.webinarPrismic && this.props.webinarPrismic.webinarsList[0];
        return (
            <div className="col-12 webinar-inner-info">
                <h1 className="heading-main"> {webinar.title}</h1>
                <p className="body-copy">{webinar.description}</p>
            </div>
        );
    };
}

WebinarInnerInfo.propTypes = {
    webinar: PropTypes.object.isRequired,
};

export default WebinarInnerInfo;



// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/WebinarInnerInfo.js